"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.list.title': 'Tutorials',
    'tutorial.list.empty.title': 'No Tutorials Found',
    'tutorial.list.empty.message': 'Create your first tutorial to get started with interactive learning experiences.',
    'tutorial.expired': 'Expired',
    'tutorial.draft': 'Draft',
};
